import { FormatMixin, DotnetMixin } from '@devsquared/d2kit/src/js/mixins';
import Vue from 'vue';
import D2Kit from '@devsquared/d2kit';

Vue.mixin(DotnetMixin);
Vue.mixin(FormatMixin);

Vue.use(D2Kit, {
  colors: {
    primary: {
      100: '#f6f3ea',
      200: '#EDE8DA',
      300: '#E1DAC3',
      400: '#CBBF97',
      500: '#7c6d3d',
      600: '#A3935F',
      700: '#6D6240',
      800: '#514930',
      900: '#363120',
    },
    secondary: {
      100: '#F5F6F7',
      200: '#E6E8EB',
      300: '#D7DBDF',
      400: '#B8BFC7',
      500: '#9AA4AF',
      600: '#8B949E',
      700: '#5C6269',
      800: '#454A4F',
      900: '#2E3135',
    },
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    error: '#DC3545',
    success: '#023C2E',
    green: {
      100: '#E6ECEA',
      200: '#C0CECB',
      300: '#9AB1AB',
      400: '#4E776D',
      500: '#023C2E',
      600: '#023629',
      700: '#01241C',
      800: '#011B15',
      900: '#01120E',
    },
    gray: {
      100: '#f7fafc',
      200: '#edf2f7',
      300: '#e2e8f0',
      400: '#cbd5e0',
      500: '#a0aec0',
      600: '#718096',
      700: '#4a5568',
      800: '#2d3748',
      900: '#1a202c',
    },
  },
});